import {SectionCover} from './SectionCover';
import coverImage from '../../../../assets/pdf/sections/three.png';

export const SectionCoverThree = () => {
  return <SectionCover sectionTitle={'sectionPages.three'} coverImage={coverImage} />;
};
